import React from 'react';
import dealersListPageHelper from 'shared/routes/dealers';
import LINKS from 'desktop/constants/navigation';
import { setTargetingArguments } from 'shared/actions/globals';
import Dealers from './Dealers';
import Layout from '../../components/Layout';

async function action(params) {
  const { store } = params;
  const data = await dealersListPageHelper(params);

  if (!data) {
    return null;
  }

  const {
    url,
    currentPage,
    targetingArguments,
    title,
    description,
    metaHeader,
    queryParams,
    isLastPage,
    topDealerRequestObj,
    transportLinks,
    location,
    transportType,
  } = data;
  store.dispatch(setTargetingArguments(targetingArguments));
  return {
    chunks: ['dealers'],
    title,
    description,
    page: currentPage,
    isLastPage,
    routeName: 'dealers',
    shouldSetNoIndex: false,
    shouldSetIndex: true,
    component: (
      <Layout withBranding navLinks={LINKS.SEARCH.avto} currentRoute={url.replace('/avto/', '/')}>
        <Dealers
          queryParams={queryParams}
          topDealerRequestObj={topDealerRequestObj}
          currentPage={currentPage}
          transportType={transportType}
          url={url}
          query={params.query}
          location={location}
          transportLinks={transportLinks}
          title={metaHeader}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/dealers/index.js